// TODO js && aro
import { IAccordionDirective, IAccordionDirectiveInjectionToken } from './iAccordionDirective';
import { IAccordionItemDirective } from './iAccordionItemDirective';
import { Directive, HostBinding, Inject, Input, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[navAccordionItem]',
})
export class AccordionItemDirective implements IAccordionItemDirective, OnInit, OnDestroy {
  @Input() group: any;

  @Input() type: 'link' | 'sub' | 'extLink' | 'extTabLink' | 'envTabLink';

  protected OPEN = false;

  protected nav: IAccordionDirective;

  @HostBinding('class.open')
  @Input()
  get open(): boolean {
    return this.OPEN;
  }

  set open(value: boolean) {
    // Only sub menu can be open
    this.OPEN = this.type === 'sub' && value;
    if (value) {
      this.nav.closeOtherLinks(this);
    }
  }

  constructor(@Inject(IAccordionDirectiveInjectionToken) nav: IAccordionDirective) {
    this.nav = nav;
  }

  ngOnDestroy(): any {
    this.nav.removeGroup(this);
  }

  ngOnInit(): any {
    this.nav.addLink(this);
  }

  toggle(): any {
    this.open = !this.open;
  }
}
